import React, { useState } from 'react';
import { Col, Modal, Row, Form } from 'react-bootstrap';
import headQuarter from '../../../assets/images/CustomerManagement/head-quarter.svg'
import customerImg from '../../../assets/images/CustomerManagement/customer-img.svg'
import dotImg from '../../../assets/images/CustomerManagement/dot-img.svg'
import businessUnit from '../../../assets/images/CustomerManagement/business-unit.svg'
import branchInformation from '../../../assets/images/CustomerManagement/branch-plant-information.svg'
import storageLocationImg from '../../../assets/images/CustomerManagement/storage-location.svg'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import calendar from '../../../assets/images/Dashboard/calendar-icon.svg'
import SbCancelBtn, { SbAddBtn, SBPreviousBtn, SBSaveUpdateBtn } from '../../Buttons/Buttons';

const contactOptions = [
    { value: '+91', label: '+91' },
    { value: '+1', label: '+1' },
    { value: '+44', label: '+44' },
];
const AddMaterialMasterExtended = ({ open, handleClose }) => {
    const [customer, setCustomer] = useState({
        companyName: '',
        contactName: '',
        email: '',
        noOfLicense: '',
        contactNumber: '',
        classification: '',
        relationshipType: '',
        address: '',
        zipCode: '',
        startDate: '',
        endDate: '',
        assignedModules: '',
    });
    const [selectedOption, setSelectedOption] = useState({ value: "+91", label: "+91" })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomer((prevCustomer) => ({
            ...prevCustomer,
            [name]: value,
        }));
    };

    const [businessUnits, setBusinessUnits] = useState([]);

    const handleAddBusinessUnit = () => {
        setBusinessUnits(prevUnits => [...prevUnits, {}]); // Adding an empty object as a placeholder
    };
    const [branchPlant, setBranchPlant] = useState([]);

    const handleAddBranchPlant = () => {
        setBranchPlant(prevUnits => [...prevUnits, {}]); // Adding an empty object as a placeholder
    };

    const [storageLocation, setStorageLocation] = useState([])
    const handleAddStorage = () => {
        setStorageLocation(prevUnits => [...prevUnits, {}]); // Adding an empty object as a placeholder
    };

    const [step, setStep] = useState(1); // 1 for initial step, 2 for business units

    const handleNextStep = () => {
        setStep(prevStep => (prevStep < 4 ? prevStep + 1 : prevStep)); // Move to next step if not on the last step
    };

    const handleBackStep = () => {
        setStep(prevStep => (prevStep > 1 ? prevStep - 1 : prevStep)); // Move to previous step if not on the first step
    };

    return (
        <Modal show={open} onHide={handleClose} className='add-customer-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Add Material Master Extended</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='add-customer-menus'>
                    <Col
                        className={`add-customer-menus-names ${step >= 1 ? 'step-active' : 'step-remaining'}`}
                    >
                        <img src={headQuarter} alt="" />
                        <p>
                            Purchasing /
                            <br />Inventory Data
                        </p>


                    </Col>
                    <Col className='add-customer-dots'>
                        <img src={dotImg} alt="" />
                    </Col>
                    <Col
                        className={`add-customer-menus-names ${step >= 2 ? 'step-active' : step === 1 ? 'step-next' : 'step-remaining'}`}
                    >
                        <img src={businessUnit} alt="" />
                        <p>Material Requirement
                            <br /> Planning (MRP 1/2/3/4)
                        </p>
                    </Col>
                    <Col className='add-customer-dots'>
                        <img src={dotImg} alt="" />
                    </Col>
                    <Col
                        className={`add-customer-menus-names ${step >= 3 ? 'step-active' : step === 2 ? 'step-next' : 'step-remaining'}`}
                    >
                        <img src={branchInformation} alt="" />
                        <p>Accounting
                            <br /> & Costing
                        </p>
                    </Col>
                    <Col className='add-customer-dots'>
                        <img src={dotImg} alt="" />
                    </Col>
                    <Col
                        className={`add-customer-menus-names ${step >= 4 ? 'step-active' : step === 3 ? 'step-next' : 'step-remaining'}`}
                    >
                        <img src={storageLocationImg} alt="" />
                        <p>Special
                            <br /> Features
                        </p>
                    </Col>
                </Row>
                {step === 1 && (
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Material Number</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Long Description</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Purchasing Group</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={options}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Purchase Order Size</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Lead Time (PDT)</label>
                                        <div className='customer-contact-fields-div'>
                                            <Form.Control type="text" />
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Plant Specific Material Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
                {step === 2 && (
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>MRP Group</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>MRP Type</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Lot Size Procedure</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Material Number</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Long Description</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Purchasing Group</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={options}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Replenishment Lead Time</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Safety Stock</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>MRP Area</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Procurement Type</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Special Procurement</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Production Storage Location</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Sloc for External Procurement</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>GR Processing Time</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Planned Delivery Time</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Schedule Margin Key</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Service Level (%)</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Availability Check</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Criticality code</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>FSN Type</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>SDE Analysis</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Capital Spares</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Fixed Lot Size</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Extended Date of Materials</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
                {step === 3 && (
                    <Row className='customer-form-fields customer-branch-plant-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Moving Average Price</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Standard Price</label>
                                        <Form.Control type="text" />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>currency</label>
                                        <Select
                                            // className='customer-contact-select '
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            value={selectedOption.value}
                                            // onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Valuation Class</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            // onChange={handleChange}
                                            // options={options}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Valuation Type</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            // onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Price Unit</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedOption}
                                            // onChange={handleChange}
                                            // options={contactOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Price Control</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>LIFO Data</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
                {step === 4 && (
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Tracked in SAP</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Is Repairable</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div></Col>
                                <Col md={4}>
                                    <div>
                                        <label>Inspection Required</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Requires Preservation</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Post to Inspection Stock</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Dual UOM</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Dual Quantity</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Serial Level</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Batch Serial Indicator</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Shelf Life</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Storage Conditions</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Label Type</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>PI indicator for CC</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Locator Control</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>BOM Control</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Availability to Promise (ATP)</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Alternate UOM</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Alt Conversion</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Handling Unit Enabled</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Variant Allowed (Y/N)</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={enablingOptions}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
            </Modal.Body >
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={handleClose} />
                {/* {step === 2 && <SBPreviousBtn btnName="Previous" onClickEffect={handleBackStep} />} */}
                {/* <SBSaveUpdateBtn btnName="Next" onClickEffect={handleNextStep} /> */}
                {step > 1 && <SBPreviousBtn btnName="Previous" onClickEffect={handleBackStep} />}
                {step < 4 ? <SBSaveUpdateBtn btnName="Next" onClickEffect={handleNextStep} /> : <SBSaveUpdateBtn btnName="Save" onClickEffect={handleNextStep} />}
            </Modal.Footer>
        </Modal >
    );
};

export default AddMaterialMasterExtended;

